import { useQuery } from '@tanstack/react-query';
import { format, startOfMonth } from 'date-fns';
import { supabase } from '@/integrations/supabase/client';

import { fetchConvergenciaSaldoLote as buscar, type ConvergenciaSaldoLote } from '../../../../backend/src/domain/comissao/ConvergenciaSaldoLote';
export * from '../../../../backend/src/domain/comissao/ConvergenciaSaldoLote';
export const fetchConvergenciaSaldoLote = (competencia: Date) => buscar(competencia, supabase);
export function useConvergenciaSaldoLote(competencia: Date, enabled = true) {
  const mes = format(startOfMonth(competencia), 'yyyy-MM');
  return useQuery<ConvergenciaSaldoLote>({
    queryKey: ['convergencia-saldo-lote', mes],
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
    placeholderData: (prev) => prev,
    queryFn: () => fetchConvergenciaSaldoLote(competencia),
  });
}
